import React, {useMemo, useRef, useState} from 'react';
import {Button, Input, InputNumber, Radio, Select as AntSelect, Space, Typography} from 'antd';
import Form, {FormInputComponent} from "../../../components/form/Form";
import {useProjectForm} from "../../../providers/ProjectFormProvider";
import Project from "../../../models/Project";

const { Title, Text } = Typography;
const { Option } = AntSelect;
const ExpenseForm = (props) => {

    const [formModel, setFormModel] = useState(props.model?.id ? (
        TB.cloneDeep({
            ...props.model,
            is_billable: !!props.model?.billable_amount,
            percent_markup: ((props.model?.billable_amount - props.model?.amount) / props.model?.amount) * 100,
            billed_method: 'amount'
        })
    ) : TB.cloneDeep(props.model || {is_billable: false, is_reimbursable: false, billed_method: 'amount'}));

    // Determine initial expense category based on existing model type
    const getInitialCategory = () => {
        if (props.model?.type) {
            return ['Admin Fee', 'Background Check'].includes(props.model.type) ? 'project_fee' : 'project_expense';
        }
        return null;
    };

    const [expenseCategory, setExpenseCategory] = useState(getInitialCategory());
    const [isBilledAmountFocused, setIsBilledAmountFocused] = useState(false);

    console.log('ExpenseForm', formModel)
    const formRef = useRef(null);
    const {project, isLoading, isProjectUpdating: isDisabled,updateProjectExpenses, error, refetch} = useProjectForm();

    // Get expense types from Laravel config
    const allExpenseTypes = laravel.contract_line_item_types;

    // Filter expense types based on category
    const expenseTypes = expenseCategory === 'project_expense'
        ? allExpenseTypes.filter(type => !['Admin Fee', 'Background Check'].includes(type))
        : ['Admin Fee', 'Background Check'];

    const handleFinish = async (model) => {
        let updatedItems;

        console.log('handleFinish', model)
        if (model?.id) {
            // Update existing item
            updatedItems = TB.map(project.contract_line_items || [],item =>
                item.id === model.id
                    ? {
                        ...item,
                        ...model,
                        type: model.type,
                        position_id: model.position_id || null,
                        is_billable: model.is_billable,
                        is_reimbursable: model.is_reimbursable,
                        amount: model.amount || 0,
                        memo: model.memo || '',
                        admin_notes: model.admin_notes || '',
                        percent_markup: (model.percent_markup || 0) / 100,
                    }
                    : item
            );
        } else {
            // Add new item
            updatedItems = [
                ...(project.contract_line_items || []),
                {
                    ...model
                }
            ];
        }

        const payload = { contract_line_items: TB.map(updatedItems, item => {
            if (item.type === 'Admin Fee' || item.type === 'Background Check') {
                item.is_billable = true;
            }
            return item;
        })};

        let success = await updateProjectExpenses(payload);
        if (success) {
            return props.onCancel()
        }
    };

    const isFormValid = useMemo(() => {
        if (expenseCategory === 'project_fee') {
            return formModel.amount > 0 || formModel.billable_amount > 0
        }

        return true
    }, [
        formModel.amount,
        formModel.billable_amount,
        expenseCategory
    ]);

    const handleCancel = () => {
        setFormModel({});
        formRef.current?.forceReset({});
        return props.onCancel();
    };
    return (
        <div style={{
            backgroundColor: '#f9f9f9',
            padding: '16px',
            marginBottom: '16px',
            borderRadius: '4px',
            border: '1px solid #f0f0f0'
        }}>
            <Form
                ref={formRef}
                model={formModel}
                onChange={(model) => {
                    console.log('onchange', model)

                    let updates = {...formModel};
                    for (let [key,value] of Object.entries(model)) {
                        updates = TB.set(updates, key, value)
                    }

                    if (updates.is_billable && !formModel.is_billable && expenseCategory !== 'project_fee') {
                        updates.billable_amount = updates.amount;
                        updates.percent_markup = 0;
                        updates.clientBillable = updates.amount;
                        updates.billed_method = 'amount'
                    }
                    if (!updates.is_billable && formModel.is_billable && expenseCategory !== 'project_fee') {
                        updates.billable_amount = 0;
                        updates.percent_markup = 0;
                        updates.clientBillable = 0;
                        updates.billed_method = 'amount'
                    }
                    if (updates.is_reimbursable && !formModel.is_reimbursable) {
                        updates.talentReimbursable = updates.amount;
                    }
                    if (!updates.is_reimbursable) {
                        updates.talentReimbursable = 0;
                    }
                    console.log('onchange', updates)
                    setFormModel(updates)
                }}
                onSubmit={() => handleFinish(formModel)}
                submitButton={false}
                validateBeforeSubmit={true}
                minimal
                background="transparent"
                fields={[]}
                isDisabled={isDisabled}
            >
                <div className="flex flex-col gap-3">
                    {/* Add new line item Selection */}
                    <div className="pb-3 border-b flex flex-row items-center gap-8 border-gray-300">
                        <label className="text-sm font-medium mb-2">
                            {props.model?.id ? 'Edit line item':'Add new line item'} <span className="text-red-500">*</span>
                        </label>
                        <Radio.Group
                            value={expenseCategory}
                            onChange={async (e) => {
                                const newCategory = e.target.value;
                                await setExpenseCategory(newCategory);

                                if (newCategory === 'project_fee') {
                                    await setFormModel({
                                        ...formModel,
                                        is_billable: true,
                                        is_reimbursable: undefined,
                                        billed_method: 'amount'
                                    })
                                }
                                // Reset type and set default for Other Fee
                                formRef?.current?.forceReset({
                                    ...formModel,
                                    clientBillable: undefined,
                                    percent_markup: undefined,
                                    billable_amount: undefined,
                                    amount: undefined,
                                    type: newCategory === 'project_fee' ? 'Admin Fee' : 'Total Client Billable Expenses',
                                    is_reimbursable: newCategory === 'project_fee' ? undefined : formModel.is_reimbursable,
                                    is_billable: newCategory === 'project_fee' ? true : undefined,
                                    billed_method: 'amount'
                                });
                            }}
                            optionType="button"
                            buttonStyle="solid"
                            className="flex gap-2"
                        >
                            <Radio value="project_expense">Project Expense</Radio>
                            <Radio value="project_fee">Project Fee</Radio>
                        </Radio.Group>
                    </div>

                    <div className="grid grid-cols-3 gap-3">
                        <FormInputComponent
                            fieldName="type"
                            value={formModel.type}
                            label="Expense Type"
                            type="antd-input"
                            required={true}
                            disabled={!expenseCategory || isDisabled}
                        >
                            <AntSelect
                                placeholder={expenseCategory ? "Select expense type" : "Select category first"}
                                disabled={!expenseCategory || isDisabled}
                            >
                                {expenseTypes.map(type => (
                                    <Option key={type} value={type}>{type}</Option>
                                ))}
                            </AntSelect>
                        </FormInputComponent>
                    </div>
                    <div className="grid grid-cols-3 gap-3">

                        <FormInputComponent
                            fieldName="amount"
                            value={formModel.amount}
                            label={expenseCategory !== 'project_fee' ? "Planned Amount" : 'Cost to Wripple'}
                            type="antd-number"
                            required={false}
                            validation={{
                                rules: {
                                    feeWithoutBillable: (model, value) => {
                                        console.log('feeWithoutBillable', {expenseCategory, value, model})
                                        if (expenseCategory === 'project_fee' && model.billable_amount === 0 && !value) {
                                            return 'Required if Billed Amount is $0'
                                        }
                                        if (expenseCategory === 'project_fee' && !!value || value < 0) {
                                            return 'Amount is required even if $0'
                                        }
                                        return true;
                                    },
                                },
                            }}
                            disabled={!expenseCategory || isDisabled}
                        >
                            <InputNumber
                                style={{ width: '100%' }}
                                min={0}
                                step={0.01}
                                precision={2}
                                formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                placeholder="0.00"
                                disabled={!expenseCategory || isDisabled}
                            />
                        </FormInputComponent>

                        {expenseCategory === 'project_fee' ? (
                            <FormInputComponent
                                fieldName="billable_amount"
                                value={formModel.billable_amount}
                                label="Billed Amount"
                                type="antd-number"
                                required={false}
                                validation={{
                                    rules: {
                                        billableWithoutInternal: (model, value) => {
                                            if (expenseCategory === 'project_fee' && model.amount === 0 && !value) {
                                                return 'Required if Cost to Wripple is $0'
                                            }
                                            if (expenseCategory === 'project_fee' && (!value || value < 0)) {
                                                return 'Billed Amount required even if $0'
                                            }
                                            return true;
                                        },
                                    },
                                }}
                                disabled={!expenseCategory || isDisabled}
                            >
                                <InputNumber
                                    style={{ width: '100%' }}
                                    min={0}
                                    step={1}
                                    precision={2}
                                    formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    placeholder="0.00"
                                    disabled={!expenseCategory || isDisabled}
                                />
                            </FormInputComponent>
                        ) : null}
                    </div>

                    {expenseCategory === 'project_expense' && (
                        <React.Fragment>
                            <div className="flex flex-row items-start gap-6">
                                <FormInputComponent
                                    fieldName="is_billable"
                                    value={formModel.is_billable}
                                    label="Billable to Client?"
                                    className="min-w-[200px]"
                                    type="antd-input"
                                    disabled={!expenseCategory || isDisabled}
                                >
                                    <Radio.Group
                                        className="flex gap-2"
                                        optionType="button"
                                        buttonStyle="solid"
                                        disabled={!formModel.amount || !expenseCategory || isDisabled}
                                    >
                                        <Radio value={true}
                                               className="flex flex-col items-start justify-center">
                                            Yes
                                        </Radio>
                                        <Radio value={false}
                                               className="flex flex-col items-start justify-center">
                                            No
                                        </Radio>
                                    </Radio.Group>
                                </FormInputComponent>

                                {formModel.amount && formModel.is_billable && (
                                    <FormInputComponent
                                        fieldName="billed_method"
                                        value={formModel.billed_method}
                                        label="Billable Method"
                                        className="min-w-[200px]"
                                        type="antd-input"
                                        disabled={!expenseCategory || isDisabled}
                                    >
                                        <Radio.Group
                                            className="flex gap-2"
                                            optionType="button"
                                            buttonStyle="solid"
                                            disabled={!expenseCategory || isDisabled}
                                        >
                                            <Radio value={'amount'}
                                                   className="flex flex-col items-start justify-center">
                                                By Total Amount Billed
                                            </Radio>
                                            <Radio value={'markup'}
                                                   className="flex flex-col items-start justify-center">
                                                By % Markup
                                            </Radio>
                                        </Radio.Group>
                                    </FormInputComponent>
                                )}


                            </div>
                            {formModel.is_billable && (
                                <div className={TB.mapClass("self-start flex gap-6 items-start justify-start", {
                                    'flex-row': formModel.billed_method !== 'markup',
                                    'flex-row-reverse': formModel.billed_method === 'markup',
                                })}>
                                    <div className="flex flex-col mb-4">
                                        <label className="col-form-label text-sm font-medium">
                                            Billed Amount{formModel.billed_method === 'markup' && ' (w / markup)'}
                                        </label>
                                        <InputNumber
                                            style={{width: '100%'}}
                                            min={0}
                                            step={1}
                                            precision={2}
                                            value={formModel.billable_amount}
                                            onChange={async (value) => {
                                                const billable_amount = value;
                                                if (billable_amount && formModel.amount && formModel.billed_method === 'amount') {

                                                    let percent_markup = formModel.percent_markup || 0
                                                    if (billable_amount && formModel.amount) {
                                                        // Round billed amount up to nearest cent
                                                        const roundedBilledAmount = Math.ceil(billable_amount * 100) / 100;
                                                        // Calculate new markup percentage based on rounded billed amount
                                                        const newMarkupPercent = ((roundedBilledAmount - formModel.amount) / formModel.amount) * 100;
                                                        // Round to 6 decimal places
                                                        const roundedMarkupPercent = Math.round(newMarkupPercent * 1000000) / 1000000;

                                                        percent_markup = roundedMarkupPercent

                                                    }
                                                    setFormModel({
                                                        ...formModel,
                                                        billable_amount,
                                                        percent_markup
                                                    })
                                                }
                                            }}
                                            formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                            placeholder="0.00"
                                            disabled={!formModel.billed_method || formModel.billed_method === 'markup' || !expenseCategory || isDisabled}
                                        />
                                    </div>
                                    <div className="flex flex-col mb-4 min-w-[200px]">
                                        <label className="col-form-label text-sm font-medium">
                                            Markup %
                                        </label>
                                        <InputNumber
                                            style={{ width: '100%' }}
                                            min={0}
                                            max={100}
                                            step={1}
                                            precision={8}
                                            value={formModel.percent_markup}
                                            onChange={async (value) => {
                                                if(formModel.billed_method === 'markup') {
                                                    let percent_markup = parseFloat(value);
                                                    let billable_amount = Math.ceil( formModel.amount * (1 + (percent_markup / 100)) * 100) / 100
                                                    setFormModel({
                                                        ...formModel,
                                                        percent_markup,
                                                        billable_amount
                                                    })
                                                }
                                            }}
                                            formatter={value => value ? `${value}%` : undefined}
                                            parser={value => value.replace('%', '')}
                                            placeholder={'-'}
                                            disabled={!formModel.billed_method || formModel.billed_method === 'amount' || !expenseCategory || isDisabled}
                                        />
                                    </div>
                                </div>
                            )}
                        </React.Fragment>
                    )}


                    <div className="flex flex-row items-start gap-6">
                        {expenseCategory !== 'project_fee' && (
                            <FormInputComponent
                                fieldName="is_reimbursable"
                                value={formModel.is_reimbursable}
                                label="Reimbursable to Talent?"
                                className="min-w-[200px]"
                                type="antd-input"
                                disabled={!expenseCategory || isDisabled}
                            >
                                <Radio.Group
                                    className="flex gap-2"
                                    optionType="button"
                                    buttonStyle="solid"
                                    disabled={!expenseCategory || isDisabled}
                                >
                                    <Radio value={true}
                                           className="flex flex-col items-start justify-center">
                                        Yes
                                    </Radio>
                                    <Radio value={false}
                                           className="flex flex-col items-start justify-center">
                                        No
                                    </Radio>
                                </Radio.Group>
                            </FormInputComponent>
                        )}
                        <FormInputComponent
                            fieldName="position_id"
                            value={formModel.position_id}
                            className="min-w-[400px]"
                            label="Position"
                            type="antd-input"
                            required={formModel.is_reimbursable}
                            disabled={!expenseCategory || isDisabled}
                        >
                            <AntSelect
                                placeholder={formModel.is_reimbursable ? "Select role (required)" : "Select role (optional)"}
                                allowClear
                                disabled={!expenseCategory || isDisabled}
                            >
                                {(project?.positions || []).map(position => (
                                    <Option key={position.id} value={position.id}>
                                        {position.title || position.name}
                                    </Option>
                                ))}
                            </AntSelect>
                        </FormInputComponent>

                    </div>

                    <div className="grid grid-cols-2 gap-3">
                        <FormInputComponent
                            fieldName="memo"
                            value={formModel.memo || ''}
                            label="Notes (Visible to Client)"
                            type="antd-input"
                            required={false}
                            disabled={!expenseCategory || isDisabled}
                        >
                            <Input.TextArea rows={4} placeholder="Enter notes" disabled={!expenseCategory || isDisabled} />
                        </FormInputComponent>

                        <FormInputComponent
                            fieldName="admin_notes"
                            value={formModel.admin_notes || ''}
                            label="Admin Notes (not visible to client)"
                            type="antd-input"
                            required={false}
                            disabled={!expenseCategory || isDisabled}
                        >
                            <Input.TextArea rows={4} placeholder="Enter administrator notes" disabled={!expenseCategory || isDisabled} />
                        </FormInputComponent>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
                    <Space>
                        <Button onClick={handleCancel} disabled={isDisabled}>
                            Cancel
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={isDisabled}
                            disabled={!isFormValid || isDisabled || !expenseCategory}
                        >
                            {isDisabled ? 'Submitting...' : 'Submit'}
                        </Button>
                    </Space>
                </div>
            </Form>
        </div>
    )
};

export default ExpenseForm;